import apiFetch from './apiFetch';
import { getPendingOutbox, updateOutbox, removeFromOutbox } from './offlineDb';

const MAX_RETRIES = 5;
// Keys that belong to outbox metadata, not to the checkup FormData
const OUTBOX_META = new Set(['status', 'retry_count', 'last_error', 'created_at', 'photos']);

let _syncing = false;

export function isSyncing() {
  return _syncing;
}

export async function syncOutbox(onProgress) {
  if (_syncing || !navigator.onLine) return;
  _syncing = true;

  try {
    const entries = await getPendingOutbox();

    for (const entry of entries) {
      if (!navigator.onLine) break;
      if ((entry.retry_count || 0) >= MAX_RETRIES) continue;

      await updateOutbox(entry.client_id, { status: 'sending' });
      if (onProgress) onProgress();

      try {
        const form = new FormData();
        for (const [k, v] of Object.entries(entry)) {
          if (OUTBOX_META.has(k) || v === null || v === undefined) continue;
          form.append(k, String(v));
        }
        for (const photo of entry.photos || []) {
          form.append('files', new Blob([photo.data], { type: photo.type }), photo.name);
        }

        const res = await apiFetch('/api/pole-checkups', { method: 'POST', body: form });

        if (res.ok) {
          await removeFromOutbox(entry.client_id);
        } else if (res.status === 400) {
          // Bad payload — won't fix on retry
          const text = await res.text().catch(() => '');
          await updateOutbox(entry.client_id, {
            status: 'failed',
            retry_count: MAX_RETRIES,
            last_error: text || 'Bad request',
          });
        } else {
          throw new Error(`HTTP ${res.status}`);
        }
      } catch (e) {
        // Auth errors — stop syncing entirely
        if (e?.status === 401 || e?.status === 403) break;

        await updateOutbox(entry.client_id, {
          status: 'failed',
          retry_count: (entry.retry_count || 0) + 1,
          last_error: e.message,
        });
      }

      if (onProgress) onProgress();
    }
  } finally {
    _syncing = false;
    if (onProgress) onProgress();
  }
}
